import React, { useState, useEffect } from "react";
import { sample, isEmpty } from "lodash";

import { getPosts } from "../../../api/blogs";
import "./styles.scss";

const BlogSection = () => {
  const [blog, setBlog] = useState({});

  useEffect(() => {
    getPosts().then(({ data }) => {
      if (data.length) setBlog(sample(data));
    });
  }, []);

  return (
    !isEmpty(blog) && (
      <>
        {/* <div id="random_blog" className="random-blog-wrapper m-4">
          <h2 className="mb-3">Music Industry Tips</h2>
          <a href={"/blog/" + blog.slug}>
            {blog["_embedded"] && blog["_embedded"]["wp:featuredmedia"] && (
              <img src={blog["_embedded"]["wp:featuredmedia"][0].source_url} className="w-100" alt="" />
            )}
            <p className="blog-title mt-2">{blog.title.rendered}</p>
          </a>
        </div> */}
      </>
    )
  );
};

export default BlogSection;
